"use client";

import { logger } from "@scott/logger";
import { Component, type ErrorInfo, type ReactNode } from "react";

interface BlockErrorBoundaryState {
  hasError: boolean;
}

interface BlockErrorBoundaryProps {
  children: ReactNode;
  blockName?: string;
}

export class BlockErrorBoundary extends Component<
  Readonly<BlockErrorBoundaryProps>,
  BlockErrorBoundaryState
> {
  constructor(props: Readonly<BlockErrorBoundaryProps>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): BlockErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    logger.error("[BlockErrorBoundary] Block failed to render", {
      block: this.props.blockName,
      error: error.message,
      stack: info.componentStack,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
